import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';
import { NavItem } from 'carbonate-ui';

class Nav extends React.Component {
  render() {
    const links = this.props.links.map((link, index) => (
      <NavItem
        link={link}
        key={`nav-item-${index}`}
        className={link.className}
      />
    ));

    return (
      <nav
        className={`nav ${this.props.className}`}
      >
        <ul className="nav__list">
          {links}
          {this.props.children}
        </ul>
      </nav>
    );
  }
}

Nav.defaultProps = {
  children: null,
  className: '',
  expanded: false,
};

Nav.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  expanded: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    image: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
  })).isRequired,
};

export default Nav;
